export function onDomReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(fn, 1);
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

export function onFullyLoaded(fn) {
    window.addEventListener('load', () => {
        fn();
    });
}

export function getMeta(metaName) {
    const metaEl = document.querySelector(`meta[name='${metaName}']`);
    if (!metaEl) {
        return '';
    }

    return metaEl.getAttribute('content');
}